import { H2, PageNavigationBar, Section, Wrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import classNames from 'classnames';

import { ContentContainer, SectionContainer } from './styles';
import BackToTop from '../../elements/back-to-top';
import Banner from '../../elements/banner';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import styles from './styles.module.sass';
import textStyles from '../../application/common/text.module.sass';
import uncapFpIterator from '../../../utils/uncap-fp-iterator';

// @ts-expect-error - Automatic, Please fix when editing this file
const termsAndConditionsGenerator = (content) => () => {
  if (!content) {
    throw new Error('content is required');
  }
  const pageNavBarItems = uncapFpIterator(map)(
    // @ts-expect-error - Automatic, Please fix when editing this file
    (section) => ({
      id: section.id,
      text: section.id === 'making-a-claim' ? 'Making a claim' : section.title, // Shorten the title of `making a claim` section for the page nav bar tab as a requirement of ESD-1049
    }),
    content.sections,
  );

  return (
    <LegacyBorderedWrapper>
      <Head>
        <title>Terms and Conditions</title>
        <meta name="description" content="ahm Health Insurance Terms and Conditions." />
      </Head>
      <Banner description={content.description} note={content.note} title={content.title} />
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ContentContainer id="backToTopPoint" tabIndex="-1">
        <PageNavigationBar items={pageNavBarItems} variant="white" />
        <SectionContainer>
          {uncapFpIterator(map)(
            // @ts-expect-error - Automatic, Please fix when editing this file
            (section, id) => (
              <div key={id} id={section.id} className={classNames(textStyles.text, styles.extraPadding)}>
                <Section variant="paddingTopSpacer9">
                  <Wrapper>
                    <H2 looksLike="h3">{section.title}</H2>
                    <div className={styles.content}>{section.content}</div>
                  </Wrapper>
                </Section>
              </div>
            ),
            content.sections,
          )}
        </SectionContainer>
        <BackToTop />
      </ContentContainer>
    </LegacyBorderedWrapper>
  );
};

export default termsAndConditionsGenerator;
